export enum ChangesActionTypes {
    DEALLOCATE_REQUEST = '@@credits/DEALLOCATE_REQUEST',
}

export interface ChangesState {
}